/* tslint:disable */

/* ********************************************************
 * THIS FILE IS AUTO GENERATED BY A TOOL - DO NOT CHANGE IT
 * RUN npm run openapi-client-gen TO REGENERATE THE FILE
 * *******************************************************/

import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { VirksomhedCvrInfo } from '../models/virksomhed-cvr-info';
import { EjendomSearchResponse } from '../models/ejendom-search-response';
import { VirksomhedsOpsaetning } from '../models/virksomheds-opsaetning';
@Injectable({
  providedIn: 'root',
})
class VirksomhederService extends __BaseService {
static readonly getCvrInfoPath = '/virksomheder/cvr';
static readonly findStedByPNummerPath = '/virksomheder/sted';
static readonly minVirksomhedsOpsaetningPath = '/virksomheder/opsaetning';
static readonly saveVirksomhedsOpsaetningPath = '/virksomheder/opsaetning';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param cvr undefined
   * @return Success
   */
  private getCvrInfoResponse(cvr: string): __Observable<__StrictHttpResponse<VirksomhedCvrInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (cvr != null) __params = __params.set('cvr', cvr.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/virksomheder/cvr`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<VirksomhedCvrInfo>;
      })
    );
  }

  /**
   * @param cvr undefined
   * @return Success
   */
  getCvrInfo(cvr: string): __Observable<VirksomhedCvrInfo> {
    return this.getCvrInfoResponse(cvr).pipe(
      __map(_r => _r.body as VirksomhedCvrInfo)
    );
  }

  /**
   * @param pnummer undefined
   * @return Success
   */
  private findStedByPNummerResponse(pnummer: string): __Observable<__StrictHttpResponse<EjendomSearchResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (pnummer != null) __params = __params.set('pnummer', pnummer.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/virksomheder/sted`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<EjendomSearchResponse>;
      })
    );
  }

  /**
   * @param pnummer undefined
   * @return Success
   */
  findStedByPNummer(pnummer: string): __Observable<EjendomSearchResponse> {
    return this.findStedByPNummerResponse(pnummer).pipe(
      __map(_r => _r.body as EjendomSearchResponse)
    );
  }

  /**
   * @return Success
   */
  private minVirksomhedsOpsaetningResponse(): __Observable<__StrictHttpResponse<VirksomhedsOpsaetning>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/virksomheder/opsaetning`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<VirksomhedsOpsaetning>;
      })
    );
  }

  /**
   * @return Success
   */
  minVirksomhedsOpsaetning(): __Observable<VirksomhedsOpsaetning> {
    return this.minVirksomhedsOpsaetningResponse().pipe(
      __map(_r => _r.body as VirksomhedsOpsaetning)
    );
  }

  /**
   * @param opsaetning undefined
   */
  private saveVirksomhedsOpsaetningResponse(opsaetning: VirksomhedsOpsaetning): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = opsaetning;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/virksomheder/opsaetning`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }

  /**
   * @param opsaetning undefined
   */
  saveVirksomhedsOpsaetning(opsaetning: VirksomhedsOpsaetning): __Observable<null> {
    return this.saveVirksomhedsOpsaetningResponse(opsaetning).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module VirksomhederService {
}

export { VirksomhederService }
